import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Card, CardBody, Col, Form, Row } from "reactstrap";
import * as Yup from "yup";
import StyledButton from "../../components/Common/StyledButton";
import GSTPANModal from "../../components/CustomComponents/GSTPANModal";
import { getClientWithIdReq, updateClientReq } from "../../service/clientService";
import { setBreadcrumbItems } from "../../store/actions";

const EditClient = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [breadcrumbItems, setBreadCrubmsItems] = useState([
    { title: "Dashboard", link: "/dashboard" },
    { title: "Client", link: "/clients" },
    { title: "Edit", link: "/client/edit/:id" },
  ]);

  const [selectedFiles, setselectedFiles] = useState([]);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [status, setStatus] = useState("active")
  const [taxIdentities, setTaxIdentities] = useState([]);
  const [openGSTPANModal, setOpenGSTPANModal] = useState({
    status: false,
    values: {},
    editId: null,
  });

  const notify = (type, message, id) => {
    if (type === "Error") {
      toast.error(message, {
        position: "top-center",
        theme: "colored",
      });
    } else {
      toast.success(message, {
        position: "top-center",
        theme: "colored",
      });
      if (id) {
        let path = `/client/${id}`;
        navigate(path);
      }
    }
  };

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: null,
      contact: null,
      email: null,
      clientType: "individual",
      logo: "",
      gstin: null,
      pan: null,
      zohoCustomerId: "",
      poPrefix: "",
      status: "active",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Client Name"),
      contact: Yup.string()
        .matches(/^\d+$/, 'Contact number must only contain digits')
        .length(10, 'Contact number must be exactly 10 digits')
        .required('Contact number is required'),
      email: Yup.string().email("Please Enter Valid Email").required("Please Enter Client Email"),
      gstin: Yup.string().nullable(),
      pan: Yup.string().nullable(),
      zohoCustomerId: Yup.string().required("Please Enter Zoho Customer Id"),
    }),
    onSubmit: (values) => {
      setIsButtonLoading(true);

      const cleanedValues = { ...values };

Object.keys(cleanedValues).forEach((key) => {
  if (
    cleanedValues[key] === "" ||
    cleanedValues[key] === null ||
    cleanedValues[key] === undefined
  ) {
    delete cleanedValues[key];
  }
});

const body = {
  ...cleanedValues,
  _id: id,
  status,
};

      handleEditClient(body);
    },
  });

  const handleEditClient = async (body) => {
    try {
      setIsButtonLoading(true)
      const response = await updateClientReq(body);

      console.log("Form submitted");
      if (response.success) {
        notify("Success", response.message, id)
      }
      setIsButtonLoading(false)
    } catch (error) {
      notify("Error", error.message, id)
      setIsButtonLoading(false)
    }
};

  const handleClientStatus = async (e) => {
    setStatus(e.target.value)
  };


  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setselectedFiles(files);
  }
  
  const getClientData = async (id) => {
    try {
      const data = { _id: id };
      const res = await getClientWithIdReq(data);
  
      const client = res.payload?.client;
      const taxIdentities = res.payload?.taxIdentity;
      if (taxIdentities) {
        setTaxIdentities(taxIdentities);
      }
      if (client) {
        validation.setFieldValue("name", client.name || "");
        validation.setFieldValue("contact", client.contact || "");
        validation.setFieldValue("email", client.email || "");
        validation.setFieldValue("clientType", client.clientType || "");
        validation.setFieldValue("logo", client.logo || "");
        validation.setFieldValue("gstin", client.gstin || "");
        validation.setFieldValue("pan", client.pan || "");
        validation.setFieldValue("zohoCustomerId", client.zohoCustomerId || "");
        validation.setFieldValue("poPrefix", client.poPrefix || "");
        validation.setFieldValue("status", client.status || "");
        setStatus(client.status)
  
        setBreadCrubmsItems([
          { title: "Dashboard", link: "/dashboard" },
          { title: "Clients", link: "/clients" },
          { title: client.name, link: `/client/${id}` }, 
          { title: "Edit", link: `/client/edit/:id` }, 
        ]);
      } else {
        console.log("Client not found in response");
      }
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };
  

  useEffect(() => {
    getClientData(id);
  }, []);

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  useEffect(() => {
    props.setBreadcrumbItems("Edit", breadcrumbItems);
  }, [breadcrumbItems]);


  const handleTaxEdit = (identity) => {
    setOpenGSTPANModal({
      status: true,
      values: {
        fieldType: identity.taxType,
        fieldValue: identity.taxRegistrationNumber,
      },
      editId: identity._id,
    });
  };

  const updateTaxIdentity = (taxIdentity, isDelete = false) => {
    setTaxIdentities(prev => {
      if (isDelete) {
        return [...prev.filter(ele => ele._id !== taxIdentity._id)];
      }
      const index = prev.findIndex(item => item._id === taxIdentity._id);
  
      if (index !== -1) {
        const updated = [...prev];
        updated[index] = taxIdentity;
        return updated;
      }

      return [...prev, taxIdentity];
    });
  };

  const getTaxIdentityTable = () => {
    const orderedList = taxIdentities.sort((a,b) => a.taxType.localeCompare(b.taxType)); 
  return (
    <>
      <table className="table table-bordered align-middle mt-3">
        <thead>
          <tr>
            <th style={{ width: "30%" }}>Type</th>
            <th style={{ width: "50%" }}>Number</th>
            <th style={{ width: "20%" }}>Action</th>
          </tr>
        </thead>

        <tbody>
          {orderedList?.map((identity, index) => (
            <tr key={index}>
              <td>{identity.taxType}</td>
              <td>{identity.taxRegistrationNumber}</td>
              <td>
                <StyledButton
                  color="primary"
                  size="sm"
                  onClick={() => handleTaxEdit(identity)}
                >
                  Edit
                </StyledButton>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <StyledButton
                  color={"primary"}
                  className={"w-md mx-2"}
                  onClick={() => setOpenGSTPANModal({ status: true })}
                >
                  Add GST/PAN
                </StyledButton>
    </>
    
  );
};

  return (
    <Form className="form-horizontal mt-4" autoComplete="off" onSubmit={validation.handleSubmit}>
      <div style={{ position: "relative" }}>
        <div
          style={{
            position: "absolute",
            top: -50,
            right: 10,
            display: "flex",
          }}
        >
          <select className="form-select focus-width" name="status" value={status} onChange={handleClientStatus}>
            <option value="active">Published</option>
            <option value="inactive">Draft</option>
          </select>
          <StyledButton
            type="submit"
            color={"primary"}
            className={"w-md mx-2"}
            isLoading={isButtonLoading}
          >
            Submit
          </StyledButton>
        </div>
        <Row>
          <Col xs="8">
            <Card>
              <CardBody>
                <Row>
                  <h4 className="card-title">Client Details</h4>
                </Row>
                <Row className="mt-4">
                  <Col xs="2">
                    <div className="rounded-circle text-center">
                      <label className="item-name text-center">
                        Client Logo
                      </label>
                      {selectedFiles.length > 0 ? (
                        <img
                          data-dz-thumbnail=""
                          style={{ borderRadius: "50%" }}
                          className="avatar-sm rounded- bg-light"
                          alt={selectedFiles[0].name}
                          src={selectedFiles[0].preview}
                        />
                      ) : (
                        <Dropzone
                          onDrop={(acceptedFiles) => {
                            handleAcceptedFiles(acceptedFiles);
                          }}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div className="rounded-circle">
                              <div
                                style={{
                                  background: "#ffffff",
                                  border: "1px solid #dee2e6",
                                }}
                                className="dz-message needsclick rounded-circle"
                                {...getRootProps()}
                              >
                                <input {...getInputProps()} />
                                <i className="mdi mdi-36px mdi-cloud-upload-outline"></i>
                              </div>
                            </div>
                          )}
                        </Dropzone>
                      )}
                    </div>
                  </Col>
                  <Col>
                    <div className="mt-4">
                      <label className="item-name">Client Name</label>
                      <input
                        name="name"
                        id="name"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name || ""}
                        invalid={
                          validation.touched.name && validation.errors.name
                        }
                        className="form-control"
                        type="text"
                        placeholder="Enter your Name"
                      />
                      {validation.touched.name && validation.errors.name ? (
                        <p style={{ color: "red" }}>{validation.errors.name}</p>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col>
                    <div className="mt-3">
                      <label className="item-name">Client Phone Number</label>
                      <input
                        name="contact"
                        id="contact"
                        className="form-control"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.contact || ""}
                        invalid={
                          validation.touched.contact &&
                          validation.errors.contact
                        }
                        placeholder="Enter your number"
                      />
                      {validation.touched.contact &&
                        validation.errors.contact ? (
                        <p style={{ color: "red" }}>
                          {validation.errors.contact}
                        </p>
                      ) : null}
                    </div>
                  </Col>
                  <Col>
                    <div className="mt-3">
                      <label className="item-name">Primary Email</label>
                      <input
                        name="email"
                        id="email"
                        className="form-control"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          validation.touched.email && validation.errors.email
                        }
                        placeholder="Enter your email"
                      />
                      {validation.touched.email && validation.errors.email ? (
                        <p style={{ color: "red" }}>
                          {validation.errors.email}
                        </p>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <div>
                    <label className="col-form-label">Client Type</label>
                    <select
                      name="clientType"
                      id="clinetType"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.clientType || ""}
                      invalid={
                        validation.touched.clientType &&
                        validation.errors.clientType
                      }
                      className="form-select focus-width"
                    >
                      <option>Select Client Type</option>
                      <option value="business">Business</option>
                      <option value="individual">Individual</option>
                    </select>
                    {validation.touched.clientType &&
                      validation.errors.clientType ? (
                      <p style={{ color: "red" }}>
                        {validation.errors.clientType}
                      </p>
                    ) : null}
                  </div>
                </Row>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <h4 className="card-title">Additional Details</h4>
                <Row className="mt-4">
                  <Col>
                    <label className="item-name">Zoho Customer Id</label>
                    <input
                      name="zohoCustomerId"
                      id="zohoCustomerId"
                      className="form-control"
                      type="text"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.zohoCustomerId}
                      invalid={
                        validation.touched.zohoCustomerId &&
                        validation.errors.zohoCustomerId
                      }
                      placeholder="Enter Zoho Customer Id"
                    />
                    {validation.touched.zohoCustomerId &&
                      validation.errors.zohoCustomerId ? (
                      <p style={{ color: "red" }}>
                        {validation.errors.zohoCustomerId}
                      </p>
                    ) : null}
                  </Col>
                  <Col>
                    <label className="item-name">PO Prefix</label>
                    <input
                      name="poPrefix"
                      id="poPrefix"
                      className="form-control"
                      type="text"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.poPrefix}
                      invalid={
                        validation.touched.poPrefix &&
                        validation.errors.poPrefix
                      }
                      placeholder="Enter PO Prefix"
                    />
                    {validation.touched.poPrefix &&
                      validation.errors.poPrefix ? (
                      <p style={{ color: "red" }}>
                        {validation.errors.poPrefix}
                      </p>
                    ) : null}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col xs="4">
            <Card>
              <CardBody>
                <h4 className="card-title">Tax Details</h4>
                {getTaxIdentityTable()}
                {/* <div className="mt-3">
                  <label className="item-name">PAN</label>
                  <input
                    name="pan"
                    id="pan"
                    className="form-control"
                    type="text"
                    placeholder="Enter PAN Number"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.pan}
                    invalid={validation.touched.pan && validation.errors.pan}
                  />
                  {validation.touched.pan && validation.errors.pan ? (
                    <p style={{ color: "red" }}>{validation.errors.pan}</p>
                  ) : null}
                </div>
                <div className="mt-3">
                  <label className="item-name">GST Number</label>
                  <input
                    name="gstin"
                    id="gstin"
                    className="form-control"
                    type="text"
                    placeholder="Enter GST Number"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.gstin}
                    invalid={
                      validation.touched.gstin && validation.errors.gstin
                    }
                  />
                  {validation.touched.gstin && validation.errors.gstin ? (
                    <p style={{ color: "red" }}>{validation.errors.gstin}</p>
                  ) : null}
                </div> */}
                <GSTPANModal
                  openModal={openGSTPANModal.status}
                  setOpenModal={(status) => setOpenGSTPANModal({ status })}
                  values={openGSTPANModal.values}
                  editId={openGSTPANModal.editId}
                  clientId={id}
                  updateTaxIdentity={updateTaxIdentity}
                  notify={notify}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </Form>
  );
};

export default connect(null, { setBreadcrumbItems })(EditClient);